module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Dokumente.5a6160df.jpg";